import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ToastComponent } from 'src/app/shared/toast/toast.component';
import { QueryService } from 'src/app/services/query/query.service';
import { AreaService } from 'src/app/services/Area/area.service';
import { CallNumber } from '@ionic-native/call-number/ngx';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.page.html',
  styleUrls: ['./contact-us.page.scss'],
})
export class ContactUsPage implements OnInit {

  ngOnInit() {
  }
  dataModel:any;
  userData:any;
 constructor(
   private navCtrl:NavController,
    private callNumber:CallNumber,
    private toast:ToastComponent,
   private queryService:QueryService,
   private areaService:AreaService

 ) {
this.userData=JSON.parse(localStorage.getItem('userProfile'))
this.dataModel={
  fullName:this.userData.fullName,
  email:"",
  mobileNo:this.userData.mobileNo,
  status:"Pending",
  profileImage:this.userData.profileImage.url,
  message:"",
  userId:this.userData.id
}
 }

 goback(){
  this.navCtrl.navigateBack('/app/about');
}
submit(){
  if(this.dataModel.fullName && this.dataModel.email && this.dataModel.message){
    this.queryService.addQuery(this.dataModel).then((res:any)=>{
      this.toast.presentToastError("Your Query Submitted Successfully")
      this.dataModel={
        fullName:"",
        email:"",
        mobileNo:this.userData.mobileNo,
        status:"Pending",
        profileImage:this.userData.profileImage.url,
        message:"",
        userId:this.userData.id
      }
    })
  }else{
    this.toast.presentToastError("Please Fill All The Fields")

  }
}
ionViewDidEnter() {
  this.areaService.showHome=false

}

call(){
  this.callNumber.callNumber("+916306023551", true)
  .then(res => console.log('Launched dialer!', res))
  .catch(err => console.log('Error launching dialer', err));
}
}
